import { z } from 'zod';
import { TemplateTypesSchema } from '../aggregates/template.js';
export const ListTemplatesApiSchema = {
    query: z.object({
        type: TemplateTypesSchema.optional(),
    }),
};
export const ListTemplatesRequestSchema = ListTemplatesApiSchema.query;
